// Tiempo de inactividad en minutos antes de cerrar sesión
export const SESSION_TIMEOUT_MINUTES = 10;

// Keys de localStorage
export const TOKEN_KEY = 'token';
export const TOKEN_DATE_KEY = 'tokenDate';
